import { render, staticRenderFns } from "./PanelMain.vue?vue&type=template&id=ab47231a&scoped=true&"
import script from "./PanelMain.vue?vue&type=script&lang=js&"
export * from "./PanelMain.vue?vue&type=script&lang=js&"
import style0 from "./PanelMain.vue?vue&type=style&index=0&id=ab47231a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab47231a",
  null
  
)

export default component.exports